import {SummonDataProperty} from 'src/tracker/model/property/summon/summon-data-property'

export const brothersProperty = new SummonDataProperty(
  "4f0141f2-5a5f-4708-beff-1776f39ddc5a",
  "The Brothers",
  "Brothers",
)
